import { cn } from "@/lib/utils";
import { memo, PropsWithChildren } from "react";

interface ActiveFiltersBarTrackProps {
  barToneClass: string;
}

const ActiveFiltersBarTrackComp = ({
  barToneClass,
  children,
}: PropsWithChildren<ActiveFiltersBarTrackProps>) => (
  <div className="shrink-0 whitespace-normal">
    <div
      className={cn(
        "flex min-h-10 max-sm:flex-nowrap max-sm:gap-x-2 max-sm:overflow-x-auto max-sm:overflow-y-hidden sm:flex-wrap items-center gap-x-3 gap-y-2 border-b px-2 py-1 text-xs transition-colors",
        barToneClass,
      )}
    >
      {children}
    </div>
  </div>
);

export const ActiveFiltersBarTrack = memo(ActiveFiltersBarTrackComp);
